import React from "react";
import styles from "./Features.module.css";

const features = [
  {
    id: "guides",
    icon: "🧭",
    title: "Expert Local Guides",
    description: "Licensed drivers with 10+ years of dune-bashing experience.",
  },
  {
    id: "fleet",
    icon: "🚙",
    title: "Modern 4x4 Fleet",
    description: "Well-maintained Land Cruisers with safety checks every trip.",
  },
  {
    id: "price",
    icon: "💰",
    title: "Best Price Guarantee",
    description: "Transparent pricing with no hidden fees at checkout.",
  },
  {
    id: "support",
    icon: "🕑",
    title: "24/7 Support",
    description: "Reach us anytime on WhatsApp before, during, or after your trip.",
  },
];

function Features() {
  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Why Travelers Choose Us</h2>

        <div className="row g-3">
          {features.map((feature) => (
            <div key={feature.id} className="col-6 col-md-3">
              <div className={styles.card}>
                <span className={styles.icon}>{feature.icon}</span>
                <p className={styles.cardTitle}>{feature.title}</p>
                <p className={styles.cardDescription}>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
